import ClientInfoContainer from './clientInfo.container';

export default ClientInfoContainer;
